const config = {
  apiBaseUrl: 'https://vtrend.goodride.co.in/api',
  socketUrl: "https://vtrend.goodride.co.in",
  socketPath: "/socket.io",
  // apiBaseUrl: 'http://localhost:5001/api',
  // socketUrl: "http://localhost:5001/api",
  // socketPath: "/socket.io",
  JWT_SECRET_KEY: "carpooling",
  GOOGLE_API_KEY: "AIzaSyDM7j-B6DHn_Cj3fQE7mzQEq9W1_uVJrt0",
};



// AIzaSyCnMxChgAJv2rWTGHwo_z-szWw9iBldjJY

// map id   462aec2e3c77d57ffddec3a9

export default config;